import * as React from 'react';
import { connect } from 'react-redux';

import { IStore } from 'src/services/store';
import { ILinkCreatedProps, ILinkCreatedState } from '../types';

import {
  Button,
  CopyButton,
  QR,
  WarningBlock,
  CreateShortlink,
} from 'src/components';

class LinkCreated extends React.Component<
  ILinkCreatedProps,
  ILinkCreatedState
> {
  state: ILinkCreatedState = {
    generatedShortlink: '',
  };

  shortlinkGenerated = (url: string) => {
    this.setState({ generatedShortlink: url });
  };

  render() {
    const { link, onDuplicate, shortenerEnabled } = this.props;
    const { generatedShortlink } = this.state;
    return (
      <div className="py-8 px-10 mb-8 bg-grey rounded">
        <h2 className="text-blue font-normal mb-8">Create New Link</h2>
        <div className="max-w-lg m-auto text-center">
          <h3 className="text-green text-3xl mb-8">Link created!</h3>
          {link.trackingCodeRedirectIssue && (
            <WarningBlock>
              <p>
                <strong className="block mb-1">Target Check Warning!</strong>{' '}
                The trackinglink you have just created is currently triggering a
                redirect which deletes the trackingcode! Please check your
                trackinglink in your browser before using it, to make sure that
                no tracking data is being lost.
              </p>
            </WarningBlock>
          )}
          {link.linkCreationNotifications &&
            link.linkCreationNotifications.map((message, index) => (
              <WarningBlock key={index}>
                <div dangerouslySetInnerHTML={{ __html: message }} />
              </WarningBlock>
            ))}

          <p className="my-4">
            <strong>Campaign URL:</strong> {link.url}
            <CopyButton
              className="ml-2"
              toCopy={link.url}
              successMessage="Campaign URL copied"
            />
          </p>
          {shortenerEnabled && (
            <div className="my-2">
              {generatedShortlink ? (
                <>
                  <strong>Short link:</strong> {generatedShortlink}
                  <CopyButton
                    className="ml-3"
                    toCopy={generatedShortlink}
                    successMessage="Short link copied"
                  />
                  <QR className="ml-1" url={generatedShortlink} />
                </>
              ) : (
                <CreateShortlink
                  linkId={link.id}
                  onGenerated={this.shortlinkGenerated}
                />
              )}
            </div>
          )}
          <div className="mt-10 pt-4 border-t-2 border-grey-lighter">
            <Button
              size="small"
              primary={true}
              background="grey"
              onClick={onDuplicate}
            >
              Duplicate link
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings: { shortenerEnabled } }: IStore) => ({
  shortenerEnabled,
});

export default connect(mapStateToProps)(LinkCreated);



// WEBPACK FOOTER //
// ./src/views/LinkCreate/components/LinkCreated.tsx